import {useLayoutEffect} from 'react';
import {requestContext} from '../../../common/requestContext';

interface UseBodyScrollInIosParam {
  needBodyScroll?: boolean;
}

/**
 *  window의 scroll이 아닌 document.body의 scroll을 사용하도록 설정합니다.
 *  iOS에서 input focus할 때 scroll이 이동되는데 간헐적으로 자동완성 레이어가 뷰포트 밖으로 나가는 현상이 있습니다.
 *  input focus시에 이동시키는 window.scroll을 사용하지 않고 body의 scroll을 사용하도록 CSS 코드를 추가한 hook입니다.
 *  https://stackoverflow.com/a/29895108
 */
export function useBodyScrollInIos({
  needBodyScroll = true,
}: UseBodyScrollInIosParam) {
  const {isIos} = requestContext.requestInfo.display;

  /**
   * bodyScrollLock 관련 CSS와 상반되는 스타일을 가져서 조건이 추가되었습니다.
   * bodyScrollLock CSS 적용 이후에 다시 이 스타일 적용시 useEffect를 사용하면 스크롤 위치가 뚝뚝 변경되는 이슈가 있어
   * DOM 변경 이전에 CSS가 적용되도록 useLayoutEffect를 사용합니다.
   */
  useLayoutEffect(() => {
    if (isIos && needBodyScroll) {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
      document.body.style.cssText += '-webkit-overflow-scrolling: touch;';
      document.documentElement.style.cssText +=
        '-webkit-overflow-scrolling: touch;';
    }

    return () => {
      if (isIos) {
        document.body.style.overflow = 'visible';
        document.documentElement.style.overflow = 'visible';
        document.body.style.cssText += '-webkit-overflow-scrolling: auto;';
        document.documentElement.style.cssText +=
          '-webkit-overflow-scrolling: auto;';
      }
    };
  }, [needBodyScroll, isIos]);
}
